import React, { FC } from 'react';
import { GoBack } from '..';
import { useDocumentTitle } from '../../../hooks';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

export interface PageProps {
  children?: React.ReactNode;
  /**
   * Go back title
   */
  goBackTitle?: string;
  /**
   * Go back URL
   */
  goBackURL?: string;
  /**
   * Go back show allways
   */
  goBackShowAlways?: boolean;
  /**
   * Set to true to show a spinner while page is loading.
   */
  loading?: boolean;
  /**
   * Sub title h2
   */
  subTitle?: string;
  /**
   * Main title h1
   */
  title?: React.ReactNode;
  /**
   * Plain-text title for the browser tab when the visible title contains markup.
   */
  documentTitle?: string;
}

export const Page: FC<PageProps> = (props) => {
  useDocumentTitle(props.documentTitle ?? (typeof props.title === 'string' ? props.title : undefined));

  return (
    <div className="w-full mx-auto">
      <GoBack showAlways={props.goBackShowAlways ?? false} to={props.goBackURL} text={props.goBackTitle} />
      {!props?.loading ? (
        <>
          {props.title && <h1 className="data-hj-suppress mt-2 text-2xl font-bold">{props.title}</h1>}
          {props.subTitle && <h2 className="data-hj-suppress text-lg font-semibold mt-1">{props.subTitle}</h2>}
          {props?.children}
        </>
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
};
